import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';

import { useCheckout } from '@src/hooks/queries/cartItems';
import { useUserInfo } from '@src/hooks/userInfo';
// import { formatMoney } from '@src/utils/moneyHelpers';

import LoadingElement from '@src/components/loader';

import CartContent from './../CartContent';

import './CartModal.scss';

const CartModal = (props) => {
    const {
        onClose,
        onSubmit,
        cartItemsData,
    } = props;

    const [mutateCheckout] = useCheckout();
    const user = useUserInfo();
    const agencyMdfRemaining = user.agency.mdf_remaining;
    const isAllowToCheckout = Boolean(agencyMdfRemaining.cents >= 0);
    const requestID = user.currentCollateralRequestID;
    const requestUUID = user.currentCollateralRequestUUID;

    const handleOnSubmit = useCallback(() => {
        const cartItemIds = cartItemsData.cartItems.map((ci) => ci.id);
        mutateCheckout({ ids: cartItemIds, uuid: requestUUID }, {
            onSuccess: (response) => {
                const id = response.data.id;
                const uuid = response.data.uuid;
                onSubmit(id, uuid);
            },
            onError: (error) => {
                // eslint-disable-next-line no-console
                console.error('Error on checkout: ', error);
            },
        });
    }, [mutateCheckout, onSubmit, cartItemsData, requestUUID]);

    const handleOnContinue = useCallback(() => {
        handleOnSubmit();
    }, [handleOnSubmit]);

    return (
        <Modal
            show
            animation={false}
            className="cart-modal"
            onHide={onClose}
        >
            <Modal.Header closeButton />
            <Modal.Body className="cart-body">
                <Col className="p-2">
                    <Row>
                        {
                            (!cartItemsData || cartItemsData.loaded !== 'complete') && (
                                <LoadingElement style={{ transform: 'scale(0.5)' }} />
                            )
                        }
                        {
                            cartItemsData && cartItemsData.loaded === 'complete' && cartItemsData.cartItems?.length === 0 && (
                                <h3 className="w-100 pt-5 text-center">No Items</h3>
                            )
                        }
                        {
                            cartItemsData && cartItemsData.loaded === 'complete' && cartItemsData.cartItems?.length > 0 && (
                                <CartContent
                                    cartItems={cartItemsData.cartItems}
                                />
                            )
                        }
                    </Row>
                    <Row>
                        <Col className="agency-info">
                            <p>
                                <span className="pr-1">
                                    When ready, select the list of customers to receive your materials.
                                </span>
                            </p>
                            {/*
                            <div className="mdf-remaining w-100">
                                MDF Remaining: <b>{formatMoney(agencyMdfRemaining)}</b>
                            </div>
                            */}
                            {
                                cartItemsData && cartItemsData.cartItems?.length > 0 && (
                                    <div className="start-checkout w-100 pt-3">
                                        {
                                            !requestID && (
                                                <button
                                                    href="#"
                                                    type="button"
                                                    className="ml-button-primary w-100"
                                                    disabled={!isAllowToCheckout}
                                                    onClick={handleOnSubmit}
                                                >
                                                    Checkout
                                                </button>
                                            )
                                        }
                                        {
                                            requestID && (
                                                <button
                                                    href="#"
                                                    type="button"
                                                    className="ml-button-primary w-100"
                                                    disabled={!isAllowToCheckout}
                                                    onClick={handleOnContinue}
                                                >
                                                    Checkout
                                                </button>
                                            )
                                        }
                                    </div>
                                )
                            }
                        </Col>
                    </Row>
                </Col>
            </Modal.Body>
        </Modal>
    );
};

CartModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    cartItemsData: PropTypes.object,
};

export default React.memo(CartModal);
